import { styled } from '@mui/material/styles';

import BottomSheet from 'src/components/BottomSheet';
import DefaultInput from 'src/components/DefaultInput';

export const Container = styled('div')({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  padding: '4rem ',
  overflow: 'hidden',
});

export const ContentsContainer = styled('div')({});

export const StyledBottomSheet = styled(BottomSheet)({
  '& .MuiPaper-root': {
    height: '71rem',
    position: 'absolute',
    bottom: '0',
  },
});

export const DYDXContainer = styled('div')(({ theme }) => ({
  padding: '2.4rem',

  marginTop: '3rem',

  borderRadius: '1rem',

  color: theme.colors.base01,
  backgroundColor: theme.colors.base06,
}));

export const IconContainer = styled('div')({
  width: '4.8rem',
  height: '4.8rem',

  '& > svg': {
    width: '4.8rem',
    height: '4.8rem',
  },
});

export const DetailContainer = styled('div')({
  width: 'calc(100% - 8rem)',

  position: 'absolute',
  bottom: '13.4rem',
});

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  flexShrink: 0,
});

export const HeaderTitle = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '1',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',

  borderRadius: '2rem',
}));

export const TokenContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const TokenLeftContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1.2rem',
});

export const TokenLeftColumnContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  rowGap: '0.6rem',
});

export const TokenRightContainer = styled('div')({
  display: 'flex',
});

export const StyledInput = styled(DefaultInput)({
  height: '3rem',
});

export const TokenTextContainer = styled('div')({
  height: '4rem',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});

export const Base02Text = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

export const Divider = styled('div')(({ theme }) => ({
  width: '100%',
  height: '0.1rem',

  margin: '2.4rem 0',

  backgroundColor: theme.colors.base04,
}));
